<template>
  <v-dialog
    v-model="dialog"
    persistent
    transition="dialog-bottom-transition"
    width="500"
  >
    <v-card>
      <v-card-title>
        <strong>เพิ่มหมวดหมู่</strong>
        <v-spacer></v-spacer>
        <v-btn icon @click="close">
          <v-icon>fas fa-times</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider></v-divider>
      <v-container fluid>
        <v-layout>
          <v-flex xs12>
            <el-form :label-position="`top`" label-width="100px" size="mini">
              <el-form-item v-show="false" label="Shop ID">
                <el-input v-model="shop_id" readonly></el-input>
              </el-form-item>
              <el-form-item label="ชื่อหมวดหมู่">
                <el-input v-model="form.name"></el-input>
              </el-form-item>
              <el-form-item label="อันดับ">
                <el-input type="tel" v-model="form.rank"></el-input>
              </el-form-item>
            </el-form>
          </v-flex>
        </v-layout>
      </v-container>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="white" depressed @click="close()">ปิด</v-btn>
        <v-btn color="primary" depressed @click="save()">บันทึก</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import Service from "../../services";

export default {
  name: "create-category",
  props: {
    dialog: { default: false },
    shop_id: { default: null },
  },
  data() {
    return {
      form: {
        name: "",
        rank: 0,
      },
    };
  },
  methods: {
    close() {
      this.$emit("close");
    },
    save() {
      let data = {
        ...this.form,
        shop_id: this.shop_id,
      };
      Service.Shop.addCategory(data).then((res) => {
        if (res.success) {
          this.$emit("save");
        }
      });
    },
  },
};
</script>
